import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=4a7f7bfb&scoped=true&"
import script from "./Setting.vue?vue&type=script&lang=ts&"
export * from "./Setting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7f7bfb",
  null
  
)

export default component.exports